import React from "react";
import Grid from "@mui/material/Grid";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export const NeoPageAddButton = ({ onClick }) => {
  const content = (
    <div
      style={{
        padding: "5px",
        cursor: "pointer",
        display: "inline-block",
        borderRight: "none",
        borderLeft: "1px solid rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        style={{ cursor: "pointer", height: "100%" }}
        container
        spacing={1}
        alignItems="flex-end"
      >
        <Grid item>
          <IconButton
            size="medium"
            style={{ padding: "5px", color: "#000" }}
            aria-label="move left"
            onClick={onClick}
          >
            <AddIcon style={{ color: "#000", fontWeight: "bold" }} />
          </IconButton>
        </Grid>
      </Grid>
    </div>
  );
  return content;
};

export default NeoPageAddButton;
